import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { createNote } from "./NoteService";


export default function NoteForm(){
const nav = useNavigate();


const [title,setTitle] = useState("");
const [content,setContent] = useState("");
const [noteType, setNoteType] = useState("INFO");
const [priority, setPriority] = useState(4);
const [status, setStatus] = useState("Active");
const [secured, setSecured] = useState();
const [noteSummary, setNoteSummary] = useState("");


const submit = async (e)=>{
e.preventDefault();


const payload = { title, content, noteType, priority, status, secured, noteSummary };
await createNote(payload);


nav("/notes");
};


return (
<form style={wrap} onSubmit={submit}>
<h2>New Note</h2>


<input placeholder="Title" value={title} onChange={e=>setTitle(e.target.value)} />
<textarea placeholder="Write your note..." value={content} onChange={e=>setContent(e.target.value)} />
<select value={noteType} onChange={e=>setNoteType(e.target.value)}>
        <option value="INFO">Info</option>
        <option value="REMINDER">Reminder</option>
        <option value="WARNING">Warning</option>
</select>
<div style={{ display: "flex", gap: "6px" }}>
  {[1,2,3,4,5].map(p => (
    <button
      key={p} type="button" onClick={() => setPriority(p)}
      style={{
        padding: "8px 12px",
        borderRadius: "6px",
        border: "1px solid #ddd",
        cursor: "pointer",
        background: priority === p ? "#2563eb" : "#f3f4f6",
        color: priority === p ? "white" : "black",
        fontWeight: priority === p ? "600" : "400"
      }}>
      {p}
    </button>
  ))}
</div>
<select value={status} onChange={e=>setStatus(e.target.value)}>
        <option value="ACTIVE">Active</option>
        <option value="ARCHIVED">Archived</option>
        <option value="DONE">Done</option>
        <option value="DELTED">Deleted</option>
</select>
<div
  onClick={() => setSecured(prev => !prev)}
  style={{
    width: "46px",
    height: "26px",
    borderRadius: "13px",
    background: secured ? "#34c759" : "#e5e7eb",
    position: "relative",
    cursor: "pointer",
    transition: "background 0.25s"
  }}
>
  <div
    style={{
      width: "22px",
      height: "22px",
      borderRadius: "50%",
      background: "white",
      position: "absolute",
      top: "2px",
      left: secured ? "22px" : "2px",
      transition: "left 0.25s",
      boxShadow: "0 2px 6px rgba(0,0,0,0.25)"
    }}
  />
</div>
<textarea placeholder="Write your Summary..." value={noteSummary} onChange={e=>setNoteSummary(e.target.value)} />

<button type="submit">Save</button>
</form>
);
}


const wrap={
maxWidth:"520px",
margin:"0 auto",
display:"flex",
flexDirection:"column",
gap:"12px",
padding:"24px",
background:"#fff",
borderRadius:"16px",
boxShadow:"0 10px 25px rgba(0,0,0,0.08)"
};